import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useCountryCode } from 'src/app/shared/hooks/l10n';

import { prefetchMembershipBottomBannerDataFromApi, useMembershipBottomBannerDataFromApi } from './data';

export type MembershipBottomBannerPrefetchedContext = Readonly<{
	data: Parameters<typeof useMembershipBottomBannerDataFromApi>[0];
}>;

export type MembershipBottomBannerCombinedState = ReturnType<typeof useMembershipBottomBannerDataFromApi>;

export function useContext(
	prefetchedData?: MembershipBottomBannerPrefetchedContext,
): MembershipBottomBannerCombinedState {
	const countryCode = useCountryCode();
	return useMembershipBottomBannerDataFromApi(prefetchedData?.data, { countryCode });
}

export async function prefetchContext(context: PrefetchContext): Promise<MembershipBottomBannerPrefetchedContext> {
	return { data: await prefetchMembershipBottomBannerDataFromApi(context, { countryCode: context.l10n.countryCode }) };
}

export type MembershipBottomBannerPrefetchedDataProps = PrefetchedDataProps<MembershipBottomBannerPrefetchedContext>;
